import classNames from 'classnames';
import { FC } from 'react';

import { Flex, Grid, Link, Text } from '@servicetitan/anvil2';
import { useDependencies } from '@servicetitan/react-ioc';

import { JobItemModel, JobListModel } from '../../../models/job.model';
import { MessageType } from '../../../models/message-type.model';
import { ChatStore } from '../../../stores/chat.store';
import { formatCurrency } from '../../../utils/format-currency';
import { formatDateTime } from '../../../utils/format-date';
import { MessageCard } from '../../message-card/message-card';

interface JobListProps {
    data: JobListModel;
}

export const JobList: FC<JobListProps> = ({ data }) => {
    const [chatStore] = useDependencies(ChatStore);

    const handleShowMore = (job: JobItemModel) => {
        chatStore.enqueueMessages([
            {
                isMine: false,
                type: MessageType.RichText,
                showAvatar: true,
                text: `Here is information about the job <strong>#${job.job_id}</strong>:`,
            },
            {
                isMine: false,
                type: MessageType.JobDetails,
                data: job,
            },
        ]);
    };

    return data.jobs.map((job, index) => {
        return (
            <MessageCard
                key={job.job_id}
                className={classNames(index > 0 && 'm-t-2')}
                flexDirection="column"
            >
                <Text variant="headline" el="h3" size="small">
                    Job ID #{job.job_id}
                </Text>

                <Grid
                    templateColumns="1fr 1fr"
                    gap="2"
                    justifyContent="space-between"
                    alignItems="stretch"
                    className="m-b-1"
                >
                    <Flex direction="column">
                        <Text variant="eyebrow" className="m-b-half" size="small">
                            Job Type
                        </Text>
                        <Text className="m-b-1" size="small">
                            {job.job_type}
                        </Text>
                    </Flex>

                    <Flex direction="column">
                        <Text variant="eyebrow" className="m-b-half" size="small">
                            Start Time
                        </Text>
                        <Text className="m-b-1" size="small">
                            {formatDateTime(new Date(job.job_start_date))}
                        </Text>
                    </Flex>

                    <Flex direction="column">
                        <Text variant="eyebrow" className="m-b-half" size="small">
                            Technician
                        </Text>
                        <Text size="small">{job.technician}</Text>
                    </Flex>

                    <Flex direction="column">
                        <Text variant="eyebrow" className="m-b-half" size="small">
                            Invoice Total
                        </Text>
                        <Text size="small">{formatCurrency(job.job_invoice_total)}</Text>
                    </Flex>
                </Grid>

                <Link
                    appearance="primary"
                    quiet
                    className="m-t-1"
                    onClick={() => handleShowMore(job)}
                >
                    View more info
                </Link>
            </MessageCard>
        );
    });
};
